
import Tickets from './index'
import UnconfiguredComponent from '../common3/UnconfiguredComponent'
import get from 'lodash/get'

const TicketsEdit = props => {


    const effect = get(props,'extra.effects')

    if( ! effect ) {
        return <UnconfiguredComponent hint='No effect'/>
    }

    return <Tickets {...props}/>
}

export default TicketsEdit